import React, { useEffect, useState } from 'react'
import { apiUrl } from '../../axios';
import RightSideDetails from "../global/rightSideDetails";
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import Select from 'react-select';
import { deleteMatBook, getActiveGuests, getActiveRangeFeeMaster, getBuckets, getGreenFee, getMatBook, getMatBookSheet, getMatMasterAll, getUserTypes, postMatBook, postMatBookOffline } from '../api/matAPI';
import { getGolfUsers, getUserAll, getViewUserAll } from '../api/usersAPI';
import { getAllGuests, getAdminSettlementOptions, getGuestByCategoryID } from '../api/teeTimeAPI';

const MatBookingSheet = (props) => {

    const [isInit,                  setIsInit]                      = useState(true);
    const [rightSideDetails,        setRightSideDetails]            = useState(false);
    const [selectedDate,            setSelectedDate]                = useState(moment().toDate());
    const [selectedMat,             setSelectedMat]                 = useState(null);
    const [allMaster,               setAllMaster]                   = useState([]);
    const [bookSheetList,           setBookSheetList]               = useState([]);
    const [bookSheet,               setBookSheet]                   = useState({});
    const [usersList,               setUsersList]                   = useState([]);
    const [bookingTable,            setBookingTable]                = useState(null);
    const [holiday,                 setHoliday]                     = useState(null);
    const [serverTime,              setserverTime]                  = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
    const [userTypeOption,          setUserTypeOption]              = useState([]);
    const [selectedUserType,        setSelectedUserType]            = useState(null);
    const [selectedUser,            setSelectedUser]                = useState(null);
    const [selectedMembersGuest,    setSelectedMembersGuest]        = useState(null);
    const [membersGuestOption,      setMembersGuestOption]          = useState([]);
    const [guestList,               setGuestList]                   = useState([]);
    const [selectedGuest,           setSelectedGuest]               = useState(null);
    const [bucketList,              setBucketList]                  = useState([]);
    const [rangeFeeMaster,          setRangeFeeMaster]              = useState([]);
    const [serverTS,                setServerTS]                    = useState(null);
    const [bookingUsers,            setBookingUsers]                = useState([]);
    const [expandedPaymentDetails,  setExpandedPaymentDetails]      = useState(false);
    const [isClubSelected,          setIsClubSelected]              = useState(false);
    const [discountPercentage,      setDiscountPercentage]          = useState(null);
    const [settlementList,          setSettlementList]              = useState([]);
    const [allSettlementList,       setAllSettlementList]           = useState([]);
    
    useEffect(() => {
        props.title("Booking Sheet", "mat-sheet");
        $('#txtDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtDate').on('change', function (event) {
            setSelectedDate(event.target.value)
        });      
        fetchMatMaster();
    }, []);

    useEffect(() => {
        if (selectedDate && selectedMat) {
            fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID)
        }
    }, [selectedDate, selectedMat]);

    useEffect(() => {
        if(allMaster && allMaster.length > 0) {
            setSelectedMat(allMaster[0])
        }
    }, [allMaster])
    
    useEffect(() => {  
        if(rightSideDetails){
            Config.Core.OpenDrawer()
            fetchBuckets();
            fetchActiveRangeFeeMaster();
            fetchSettlementOptions();
        } else {
            setBookSheet({})
            setIsClubSelected(false);
            setBookingUsers([]);
            setDiscountPercentage(null);
        }
    }, [rightSideDetails]);

    useEffect(() => {       
        if (!isInit) fillDataTable();
    }, [bookSheetList, holiday, serverTime]);

    useEffect(() => {
        if (selectedUserType?.value) {
            fetchUsers(selectedUserType?.value);
        }
    }, [selectedUserType]);


    // reset states when user type changes
    useEffect(() => {
        if (!selectedUserType) return;
        if (bookSheet?.ID) return;

        // Reset Member-related state
        setSelectedUser(null);
        setUsersList([]);
        updateBookingDetails('UserID', null);

        // Reset Guest-related state
        setSelectedGuest(null);
        setGuestList([]);
        updateBookingDetails('GuestID', null);

        // Reset Members Guest state
        setSelectedMembersGuest(null);
        setMembersGuestOption([]);
        updateBookingDetails('MembersGuestID', null);
    }, [selectedUserType]);


    useEffect(() => {
        if (Number(selectedUser?.MembershipType) === 1) {
            fetchMembersGuestsByUserID(selectedUser?.ID);
        } else {
            setMembersGuestOption([]);
        }
    }, [selectedUser]);


    const resetUser = () => {
        setBookSheet(a => ({...a, UserID: '', MembersGuestID: null }));
        setSelectedUser(null);
        setSelectedMembersGuest(null);
    }

    const updateBookingDetails = (field, value) => { 
        setBookSheet((d) => {
            return { ...d, [field]: value };
        });
    };

    const togglePaymentExpansion = () => {
        setExpandedPaymentDetails(prev => !prev);
    };

    const isWeekend = () => {
        const day = moment(selectedDate, 'DD-MM-YYYY').day();
        return day === 0 || day === 6 ? 'Y' : 'N';
    };

    const fetchBookSheet = async (selectedDate, dayName, matID) => {
        try {
            const response = await getMatBook({selectedDate, dayName, matID, type: 'matBookSheet'});
            isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
            setBookSheetList(response.bookSheet);
            setHoliday(response.holiday);
            setserverTime(response.serverTimestamp);
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    }

    const fetchMatMaster = async () => {
        try {
            const mat = await getMatMasterAll();
            setAllMaster(mat); 
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    }

    const fetchUsers = async (userTypeID) => {
        try {
            if (userTypeID == 1) {
                // fetch Golf and Social membership users
                // const users = await getGolfUsers('user');
                const users = await getViewUserAll();
                if (users && users.length > 0) {
                    const mapResult = users.map((u => ({
                        ...u, Name: `${u.FirstName} ${u.LastName}`
                    })));
                    setUsersList(mapResult);
                }
                return;
            } else if (userTypeID == 2) {
                //fetch guest
                const response = await getActiveGuests();
                if (response?.allGuests.length > 0) {
                    const transformedGuests = response?.allGuests.map((g => ({
                        value: g.ID,
                        label: g.Name,
                        CategoryID: g.CategoryID,
                        SubCategoryID: g.SubCategoryID,
                        SubCategoryName: g.SubCategoryName
                    })));
                    setGuestList(transformedGuests);
                }
            }
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }

    const fetchMembersGuestsByUserID = async (userID) => {
        const response = await getAllGuests('Member', userID);
        const transformedOptions = response?.allGuests.map((g => ({
            value: g.ID,
            label: g.Name,
            SubCategoryID: g.SubCategoryID
        })));
        setMembersGuestOption(transformedOptions);
        // if doing edit operation apply existing members guest selection
        if (bookSheet?.MembersGuestID) {
            const selected = transformedOptions.find(
                g => g.value === bookSheet.MembersGuestID
            );
            setSelectedMembersGuest(selected);
        }
        return;
    };

    const fetchUserTypes = async (existingUserType = null) => {
        const response = await getUserTypes();
        const transformedOptions = response?.allUserTypes.map(u => ({
            value: u.ID,
            label: u.Name
        }));
        setUserTypeOption(transformedOptions);
        const typeValueMap = { 'User': 1, 'Guest': 2, 'MembersGuest': 1 };
        const defaultValue = existingUserType ? typeValueMap[existingUserType] : 1;
        const defaultUserTypeOption = transformedOptions.find(option => option.value === defaultValue);
        setSelectedUserType(defaultUserTypeOption);
        return;
    };

    const fetchBuckets = async () => {
        try {
            const response = await getBuckets();
            if (response?.buckets.length > 0) {
                const transformedOptions = response?.buckets.map(b => ({
                    value: b.ID,
                    label: b.Buckets
                }));
                setBucketList(transformedOptions);
            }
        } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };

    const fetchActiveRangeFeeMaster = async () => {
        const response = await getActiveRangeFeeMaster(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
        setRangeFeeMaster(response?.rangeFeeMaster);
        setServerTS(response?.serverTS);
        return;
    };

    const fetchSettlementOptions = async () => {
        try {
            const response = await getAdminSettlementOptions();
            const options = response?.settlementOptions?.map(option => ({
                label: option.Name,
                value: option.ID
            }));
            setSettlementList(options?.filter(o => o.value === 13 || o.value === 14));
            setAllSettlementList(options?.filter(o => o.value !== 13 && o.value !== 14));
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : 'Error!',
                text      : err.message,
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            });
        }
    };

    const normalizeBookingUsers = () => {
        return bookingUsers.map(u => {
            if (u.UserType === 'User') {
                return {
                    UserType      : 'User',
                    UserID        : u.ID,
                    GuestID       : null,
                    MembersGuestID: null,
                    CategoryID    : u.CategoryID,
                    SubCategoryID : u.SubCategoryID,
                    BucketID      : u.BucketID
                };
            }

            if (u.UserType === 'Guest') {
                return {
                    UserType      : 'Guest',
                    UserID        : null,
                    GuestID       : u.GuestID,
                    MembersGuestID: null,
                    CategoryID    : u.CategoryID,
                    SubCategoryID : u.SubCategoryID,
                    BucketID      : u.BucketID
                };
            }

            if (u.UserType === 'MembersGuest') {
                return {
                    UserType      : 'MembersGuest',
                    UserID        : u.UserID,
                    GuestID       : null,
                    MembersGuestID: u.MembersGuestID,
                    CategoryID    : u.CategoryID,
                    SubCategoryID : u.SubCategoryID,
                    BucketID      : u.BucketID
                };
            }
            return null;
        }).filter(Boolean);
    };

    const cancelBookingHandler = async () => {
        const btn = $('#btnCancel');
        helper.StartProcessing(btn);
        try {
            await deleteMatBook(bookSheet.ID)
            helper.StopProcessing(btn);
            fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID)
            // setTimeout(() => {
            // }, 1000);
            closeDrawer();
            swal.fire({
                icon: 'success',
                titleText: 'Booking deleted successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }

    const addBookingHandler = async () => {
        const btn = $('#btnSave');
        if (!bookSheet.BucketID) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Please select a Bucket",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }

        if (bookingUsers.length === 0) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Please select player",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }

        if (!bookSheet?.ID && !bookSheet?.PaymentMode) {
            return swal.fire({
                icon                  : 'warning',
                titleText             : 'Settle Mode Required',
                text                  : "Please select a settle mode",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
        }

        if (!bookSheet?.ID && bookSheet?.PaymentMode === 13 && !bookSheet?.ReferenceNumber) {
            return swal.fire({
                icon                  : 'warning',
                titleText             : 'Reference Number Required!',
                text                  : "Please enter a Reference Number for Offline payment.",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
        }

        if (!bookSheet.ID && bookSheet.PaymentMode === 13 && !bookSheet.PaymentMethod) {
            return swal.fire({
                icon              : 'warning',
                titleText         : 'Payment Method Required',
                text              : 'Please select a Payment Method for Offline payment.',
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            });
        }

        // const player = normalizeBookingUsers();
        helper.StartProcessing(btn);
        try {
            const bookingUser = bookingUsers.map(u => ({
                UserType        : u.UserType,
                UserID          : u.ID || null,
                GuestID         : u.GuestID || null,
                MembersGuestID  : u.MembersGuestID || null,
                SubCategoryID   : u.SubCategoryID
            }));
            const player = bookingUsers[0];
            const matBookPayload = {
                ID                        : bookSheet.ID || 0,
                MatID                     : selectedMat?.ID,
                TemplateID                : bookSheet.TemplateID,
                Type                      : selectedMat?.Type,
                BookDate                  : moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                BucketID                  : bookSheet.BucketID,
                Comment                   : bookSheet.Comment || '',
                IsClubSelected            : isClubSelected ? 'Y' : 'N',
                UserType                  : player.UserType,
                UserID                    : player.UserType === 'User' ? player.ID : null,
                GuestID                   : player.UserType === 'Guest' ? player.GuestID : null,
                MembersGuestID            : player.UserType === 'MembersGuest' ? player.MembersGuestID : null,
                SubCategoryID             : player.SubCategoryID,
                DiscountPercentage        : bookSheet?.ID ? (discountPercentage ?? 0) : (parseFloat(bookSheet.Discount) ?? 0),
                PaymentMode               : bookSheet?.PaymentMode,
                ReferenceNumber           : bookSheet?.ID ? bookSheet?.TrackingID : bookSheet?.ReferenceNumber,
                PaymentMethod             : bookSheet?.PaymentMode === 13 ? bookSheet?.PaymentMethod : null
            };
            if (bookSheet.PaymentMode === 13) {
                await postMatBookOffline(matBookPayload);
            } else {
                await postMatBook(matBookPayload);
            }
            closeDrawer();
            fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID)
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }

    }

    const validateBucket = (field, value) => {
        if (value > 4) // maximum bucket can be 4 i.e. 200 balls
            value = 4;

        if (value < 1) // minimum bucket is 1 in db i.e. 50 balls
            value = 1

        // if (value = 0)
        //     value = 1
        updateBookingDetails(field, value)
    }

    const closeDrawer = () =>{
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
        }, 200);
    }

    const addBookingUserHandler = () => {
        // Validate selection
        if (!bookSheet.UserID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select a user first'
            });
            return;
        }

        if (!bookSheet?.BucketID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select bucket'
            });
            return;
        }

        if (bookingUsers.length >= 1) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Cannot add more than 1 Player!",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }
        
        // Find selected user
        const user = usersList.find(u => u.ID === bookSheet.UserID);
        const alreadyExists = bookingUsers.some(u => u.ID === user.ID);
        if (alreadyExists) {
            swal.fire({
                icon: 'warning',
                text: 'User already added'
            });
            return;
        }
        setBookingUsers(prev => [
            ...prev,
            {
                ...user,
                UserType: 'User',
                BucketID: Number(bookSheet.BucketID) || 1
            }
        ]);
        resetUser();
        return;
    };

    const addMembersGuestHandler = () => {
        // Validate guest selection
        if (!bookSheet.MembersGuestID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select a guest first'
            });
            return;
        }

        if (!bookSheet?.BucketID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select bucket'
            });
            return;
        }

        if (bookingUsers.length >= 1) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Cannot add more than 1 Player!",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }
        // Find selected guest
        const guest = availableMembersGuests.find(g => Number(g.value) === Number(bookSheet.MembersGuestID));

        // duplicate checking
        const alreadyExists = bookingUsers.some(u => Number(u.MembersGuestID) === Number(guest.value));
        if (alreadyExists) {
            swal.fire({
                icon: 'warning',
                text: 'Guest already added'
            });
            return;
        }
        // adding guests to booking users list
        setBookingUsers(prev => [
            ...prev,
            {
                MembersGuestID: guest.value,
                Name: guest.label,
                UserType: 'MembersGuest',
                BucketID: Number(bookSheet.BucketID) || 1,
                UserID: selectedUser?.ID,
                CategoryID: guest?.CategoryID,
                SubCategoryID: guest?.SubCategoryID
            }
        ]);

        setSelectedMembersGuest(null);
        updateBookingDetails('MembersGuestID', null);
        return;
    };

    const addGuestHandler = () => {
        // Validate selection
        if (!bookSheet.GuestID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select a guest first'
            });
            return;
        }

        if (!bookSheet?.BucketID) {
            swal.fire({
                icon: 'warning',
                text: 'Please select bucket'
            });
            return;
        }

        if (bookingUsers.length >= 1) {
            swal.fire({
                icon                  : 'warning',
                text                  : "Cannot add more than 1 Player!",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
            return;
        }
        
        // Find selected guest from guestList
        const guest = guestList.find(g => Number(g.value) === Number(bookSheet.GuestID));

        // prevent duplicate adding
        const alreadyExists = bookingUsers.some(
            u => Number(u.GuestID) === Number(guest.value)
        );
        
        if (alreadyExists) {
            swal.fire({
                icon: 'warning',
                text: 'Guest already added'
            });
            return;
        }

        // add guest to booking users

        setBookingUsers(prev => [
            ...prev,
            {
                GuestID: guest.value,
                Name: guest.label,
                UserType: 'Guest',
                BucketID: Number(bookSheet.BucketID) || 1,
                CategoryID: guest?.CategoryID,
                SubCategoryID: guest?.SubCategoryID
            }
        ]);

        // Reset guest selection
        setSelectedGuest(null);
        updateBookingDetails('GuestID', null);
    };

    const removeBookingUser = (userID) => {
        // setBookingUsers(prev => prev.filter(u => u.ID !== userID));
        setBookingUsers(prev => prev.filter(u => u.ID !== userID && u.GuestID !== userID && u.MembersGuestID !== userID));
    }

    const availableUsers = usersList.filter(u => !bookingUsers.some(b => b.ID === u.ID));

    const availableMembersGuests = membersGuestOption.filter(g => !bookingUsers.some(b => b.MembersGuestID === g.value));

    const availableGuests = guestList.filter(g => !bookingUsers.some(b => Number(b.GuestID) === Number(g.value)));

    function exportSheet(btnType) {
        let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Mat Booking Sheet`;

        bookingTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });
        
        if (btnType == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        
        $('.tableexport-caption').addClass('hidden');
    }

    function fillDataTable() {
        swal.close();

        if (holiday != null) {
            $('#lblHoliday').text("Holiday : " + holiday.Name);
        } else {
            $('#lblHoliday').text("");
        }

        const dataTable = $('#tblBookSheet').KTDatatable({
            data: {
                saveState: false,
                source   : bookSheetList,
                pageSize : 20
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable  : true,
            pagination: true,
            search    : { input: $('#generalSearch')},
            columns: [               
                {  field: 'Slot',  title: 'Slot',
                    template: function (row) {
                        return `${row.SlotFrom} To ${row.SlotTo}`
                    },
                    width:250 
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template: function (row) {
                        if (row.Status != null) {
                            return `<span class="badge badge-danger">${row.Status}</span>`
                        } else {
                            return '<span class="badge badge-success"> Available </span>'
                        }
                    },
                    width: 120,
                },
                {
                    field: 'Player',
                    title: 'Player',
                    width: 120,
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    class: "clickable",
                    template: function (row) {

                        if ((row.Status == "Booked" || row.Status == null)) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        // export to excel
        const BookingTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Mat Booking Sheet`,
        });
        setBookingTable(BookingTable);
        $('.tableexport-caption').addClass('hidden');
        
        function showEditButton(row) {

            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');

            var optString = '';

            const isEdit = moment(moment(serverTime.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);

            optString += '<center>'

            if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`

            if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

            optString += '</center>'

            return optString;
        }

        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                const row = dataTable.dataSet[index];
                setBookSheet({
                    ...row, 
                    BucketID      : row.Bucket ? row.Bucket : 1,
                    Discount      : row.ID ? (row.Discount ?? 0) : (row.Discount === 0 ? '' : row.Discount),
                    UserID        : row.UserType === 'MembersGuest' ? row.UserRefID : row.UserID
                })
                if (row.ID) {
                    setBookingUsers([{
                        Name          : row.Player,
                        UserType      : row.UserType,
                        ID            : row.UserType === 'User' ? row.UserID : row.UserType === 'MembersGuest' ? row.UserRefID : null,
                        GuestID       : row.UserType === 'Guest' ? row.UserID : null,
                        MembersGuestID: row.UserType === 'MembersGuest' ? row.UserID : null,
                        SubCategoryID : row.SubCategoryID,
                        BucketID      : row.Bucket
                    }]);
                    setIsClubSelected(row.IsClubSelected === 'Y');
                    setDiscountPercentage(row.Discount || 0);
                } else {
                    setBookingUsers([]);
                }
                fetchUsers();
                fetchUserTypes(row.UserType);
                setRightSideDetails(true); 
            } 
        });
    }

    const fees = (() => {

        if (!bookingUsers || bookingUsers.length === 0) {
            return {
                greenFee: 0,
                bucketAmount: 0,
                bucketBalls: 0,
                tax: 0,
                sgst: 0,
                cgst: 0,
                total: 0
            }
        }
        const weekend = isWeekend();

        const pricingUser = bookingUsers.find(u => u.UserType === 'MembersGuest') || bookingUsers.find(u => u.UserType === 'Guest') || bookingUsers.find(u => u.UserType === 'User');

        const subCategoryID = pricingUser?.SubCategoryID || bookSheet?.SubCategoryID;

        const feeRow = rangeFeeMaster?.find(r => r.Type == selectedMat?.Type && r.IsWeekend == weekend && Number(r.SubCategoryID) === Number(subCategoryID));
        
        if (!feeRow) {
            return {
                greenFee: 0,
                bucketAmount: 0,
                bucketBalls: 0,
                tax: 0,
                sgst: 0,
                cgst: 0,
                total: 0
            }
        }

        const bucketID = Number(bookSheet?.BucketID) || 1;
        
        const bucketAmount = 
            bucketID === 1 ? feeRow?.["50Balls"] :
            bucketID === 2 ? feeRow?.["100Balls"] :
            bucketID === 3 ? feeRow?.["150Balls"] :
            bucketID === 4 ? feeRow?.["200Balls"] : 0
        
        const greenFee      = feeRow?.GreenFee || 0;
        const club          = isClubSelected ? feeRow?.Club : 0;
        const subTotal      = greenFee + bucketAmount + club;

        let discountPercent = parseFloat(bookSheet?.Discount ?? 0);
        if (isNaN(discountPercent)) discountPercent = 0;
        const discountAmount  = (subTotal * discountPercent) / 100;
        const taxableAmount   = subTotal - discountAmount;
        const sgst            = taxableAmount * 0.09;
        const cgst            = taxableAmount * 0.09;
        const tax             = sgst + cgst;
        const total           = taxableAmount + tax;

        return { greenFee, bucketAmount, bucketBalls: bucketID * 50, club, tax, sgst, cgst, total, discountAmount, subTotal };
    })();

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content" >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">Date </label>
                                    <div className="form-group col-xs-2 col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtDate" 
                                                name="txtDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            /> 
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">Mat </label>
                                    <div className="form-group col-xl-2 col-sm-3">
                                        <Select
                                            onChange={(event) => setSelectedMat(event.value)}
                                            name="ddlSelectUser"
                                            value={(selectedMat && (allMaster && allMaster.length > 0)) && {label : selectedMat.Number, value: selectedMat}}
                                            id="ddlSelectUser"
                                            className="ddlSelectUser"
                                            options={allMaster.map(c => ({
                                                label: `${c.Number}`,
                                                value: c
                                            }))}
                                        />
                                    </div>
                                    <div className="form-group col-xl-3 col-sm-3">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-2 col-sm-2">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('xlsx')}
                                                >Excel
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('csv')}
                                                >Csv 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 id="lblHoliday" className="lblHoliday"></h5>
                            <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>
                            {rightSideDetails && 
                                <RightSideDetails title="Booking Sheet" onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form id="ModalHolder" className="kt-form kt-form--label-right padding-10">
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Date</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblDate" 
                                                            disabled="disabled" 
                                                            name="lblDate" 
                                                            type="text" 
                                                            className="form-control"
                                                            value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlSlot" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Slots</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblSlot" 
                                                            disabled="disabled" 
                                                            name="lblSlot" 
                                                            type="text"
                                                            onChange={updateBookingDetails} 
                                                            className="form-control" 
                                                            value={`${bookSheet.SlotFrom} To ${bookSheet.SlotTo}`}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlType" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Type <span className="red"></span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div>
                                                            <Select 
                                                                id="ddlType" 
                                                                name="ddlType"
                                                                className="multi-custom"
                                                                placeholder="Select Type"
                                                                value={selectedUserType}
                                                                isDisabled={!!bookSheet?.ID}
                                                                onChange={(option) => {
                                                                    setSelectedUserType(option);
                                                                    updateBookingDetails('Type', option.value);
                                                                }}
                                                                options={userTypeOption}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ddlUser if selecteduserType is user */}
                                                {selectedUserType?.value === 1 && (
                                                    <div id="UserHolder">
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">User</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className="input-group" >
                                                                <div style={{width: "60%"}}  >
                                                                    <Select
                                                                        value={(usersList && usersList.length > 0 && bookSheet.UserID) && {label: `${usersList.find(m => m.ID == bookSheet.UserID).Name} (${usersList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID} || ''} 
                                                                        onChange={(event) => {
                                                                            const user = usersList.find(u => u.ID == event.value);
                                                                            setSelectedUser(user);
                                                                            updateBookingDetails('UserID', event.value)
                                                                        }}
                                                                        name="ddlUser"
                                                                        placeholder="Select User"
                                                                        id="ddlUser"
                                                                        className="ddlUser"
                                                                        isDisabled={!!bookSheet?.ID}
                                                                        options={availableUsers.map(c => ({
                                                                            label: `${c.Name} (${c.Mobile})`,
                                                                            value: c.ID
                                                                        }))}
                                                                    />
                                                                </div>
                                                                {!bookSheet?.ID && (
                                                                    <>
                                                                        <div className="input-group-append" style={{zIndex: 0}}>
                                                                            <button className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                        </div>
                                                                        <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addBookingUserHandler}>Add</button>
                                                                    </>
                                                                )}
                                                                {/* <button id="btnNewUser" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalUser" onClick={() => setShowAddUser(true)}>New</button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )}
                                                {/* display guest ddl if selectedUserType is guest */}
                                                {selectedUserType?.value === 2 && !bookSheet?.ID && (
                                                    <div id="GuestHolder">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">Guest</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group" >
                                                                    <div style={{width: "60%"}}  >
                                                                        <Select
                                                                            name="ddlGuest"
                                                                            placeholder="Select Guest"
                                                                            id="ddlGuest"
                                                                            className="ddlGuest"
                                                                            value={selectedGuest} 
                                                                            onChange={(option) => {
                                                                                setSelectedGuest(option);
                                                                                updateBookingDetails('GuestID', option.value)
                                                                            }}
                                                                            options={availableGuests}
                                                                        />
                                                                    </div>
                                                                <div className="input-group-append" style={{zIndex: 0}}>
                                                                    <button className="btn btn-secondary kt-select-reset" type="button" onClick={() => {
                                                                        setSelectedGuest(null);
                                                                        updateBookingDetails('GuestID', null);
                                                                    }}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                </div>
                                                                <button id="btnAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addGuestHandler}>Add</button>
                                                                {/* <button id="btnNewUser" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalUser" onClick={() => setShowAddUser(true)}>New</button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )}
                                                {/* add members guest ddl here conditionally display it */}
                                                {selectedUserType?.value === 1 && Number(selectedUser?.MembershipType) === 1 && !bookSheet?.ID && (
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Members Guest</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className='input-group'>
                                                                <div style={{ width: "60%" }}>
                                                                    <Select
                                                                        id="ddlMembersGuest"
                                                                        name="ddlMembersGuest"
                                                                        className="multi-custom"
                                                                        placeholder="Select Member Guest"
                                                                        value={selectedMembersGuest}
                                                                        onChange={(option) => {
                                                                            setSelectedMembersGuest(option);
                                                                            updateBookingDetails('MembersGuestID', option.value)
                                                                        }}
                                                                        options={availableMembersGuests}
                                                                    />
                                                                </div>
                                                                <div className='input-group-append' style={{ zIndex: 0 }}>
                                                                    <button 
                                                                        className="btn btn-secondary kt-select-reset" 
                                                                        type="button" 
                                                                        onClick={() => {
                                                                            setSelectedMembersGuest(null);
                                                                            updateBookingDetails('MembersGuestID', null);
                                                                        }}
                                                                    >
                                                                        <i className="flaticon2-delete kt-icon-sm padding-0"></i>
                                                                    </button>
                                                                </div>
                                                                <button id="btnAddMembersGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addMembersGuestHandler}>Add</button>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                )}
                                                {/* Bucket */}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Bucket</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <Select
                                                            id="ddlBucket"
                                                            name="ddlBucket"
                                                            className="multi-custom"
                                                            placeholder="Select Bucket"
                                                            options={bucketList}
                                                            value={bucketList.find(b => b.value === bookSheet?.BucketID) || null}
                                                            isDisabled={!!bookSheet?.ID}
                                                            onChange={(option) => {
                                                                setBookSheet(prev => ({
                                                                    ...prev,
                                                                    BucketID: option?.value,
                                                                }));
                                                                validateBucket('BucketID', option?.value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Club</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <span className="kt-switch kt-switch--sm kt-switch--icon">
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    id='ChkClub'
                                                                    checked={isClubSelected}
                                                                    onChange={(e) => setIsClubSelected(e.target.checked)}
                                                                    disabled={!!bookSheet?.ID}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Bucket</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="txtBucket" 
                                                            name="txtBucket" 
                                                            type="number"
                                                            className="form-control" 
                                                            value={bookSheet.Bucket || ''}
                                                            onChange={(event) => validateBucket('Bucket', event.target.value)} 
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Comment</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <textarea 
                                                            id="txtComment" 
                                                            name="txtComment" 
                                                            className="form-control" 
                                                            rows="3"
                                                            value={bookSheet.Comment || ''}
                                                            onChange={(event) => updateBookingDetails('Comment', event.target.value)} 
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </form>
                                            {/* players table */}
                                            {bookingUsers && bookingUsers.length > 0 && (
                                                <table id="table-user" className="table table-bordered table-hover margin-b30">
                                                    <thead className="light-grey-background">
                                                        <tr>
                                                            <th>Players</th>
                                                            {!bookSheet?.ID && <th className="text-center">Action</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bookingUsers.map((m, i) => (
                                                            <tr key={i}>
                                                                <td>
                                                                    <span className="kt-badge kt-badge--success kt-badge--dot"></span>
                                                                    &nbsp;&nbsp;
                                                                    {m.Name}
                                                                </td>
                                                                {!bookSheet?.ID && (
                                                                    <td>
                                                                        <center>
                                                                            <button 
                                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10"
                                                                                type="button" 
                                                                                onClick={() => removeBookingUser(m.ID || m.GuestID || m.MembersGuestID)}
                                                                            >
                                                                                <i className="flaticon2-rubbish-bin-delete-button"></i>
                                                                            </button>
                                                                        </center>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot></tfoot>
                                                </table>
                                                
                                            )}
                                            {/* <div className={`collapse ${expandedPaymentDetails ? "show" : ""}`}>
                                                
                                            </div> */}
                                            {bookingUsers && bookingUsers.length > 0 && (
                                                <div className="card mt-3">
                                                    {/* Header */}
                                                    <div 
                                                    className={`card-header d-flex justify-content-between align-items-center cursor-pointer ${expandedPaymentDetails ? 'active-header bg-light' : ''}`}
                                                    onClick={togglePaymentExpansion}
                                                    aria-expanded={expandedPaymentDetails}>
                                                        <div style={{ flex: 1, textAlign: "center", fontWeight: "bold", color: expandedPaymentDetails ? '#5d78ff' : 'inherit' }}>
                                                            Payment Details
                                                        </div>
                                                        <div className="card-title margin-b0">
                                                            <i
                                                            className="fa fa-chevron-right"
                                                            style={{
                                                                transform: expandedPaymentDetails ? 'rotate(90deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.3s',
                                                                color: expandedPaymentDetails ? '#5d78ff' : 'inherit'
                                                            }}
                                                            />
                                                        </div>
                                                    </div>
                                                {/* Body */}
                                                <div className={`collapse ${expandedPaymentDetails ? "show" : ""}`}>
                                                    <div className="card-body">
                                                        {/* Discount section */}
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-sm-3 text-right">Discount %</label>
                                                            <div className="col-6 input-group">
                                                                <input
                                                                    id="txtDiscount"
                                                                    name="txtDiscount"
                                                                    type="number"
                                                                    className="form-control"
                                                                    disabled={!!bookSheet.ID}
                                                                    value={bookSheet.Discount ?? 0}
                                                                    onWheel={(e) => e.currentTarget.blur()}
                                                                    onChange={(event) => {
                                                                        let value = event.target.value;
                                                                        if (value > 100) value = 100;
                                                                        if (value < 0)   value = 0;
                                                                        updateBookingDetails('Discount', value);
                                                                    }}
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="flaticon2-percentage"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {!bookSheet.ID && (
                                                            <>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Settle Mode</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <Select
                                                                            options={settlementList}
                                                                            value={settlementList.find(option => option.value === bookSheet.PaymentMode) || null}
                                                                            onChange={(event) => updateBookingDetails('PaymentMode', event.value)}
                                                                            name="ddlPaymentMode"
                                                                            placeholder="Select Settle Mode"
                                                                            id="ddlPaymentMode"
                                                                            className="ddlPaymentMode"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {bookSheet.PaymentMode === 13 && (
                                                                <>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Payment Method</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <Select
                                                                            options={allSettlementList}
                                                                            value={allSettlementList.find(option => option.value === bookSheet.PaymentMethod) || null}
                                                                            onChange={(event) => updateBookingDetails('PaymentMethod', event.value)}
                                                                            name="ddlPaymentMethod"
                                                                            placeholder="Select Payment Method"
                                                                            id="ddlPaymentMethod"
                                                                            className="ddlPaymentMethod"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                    <div className="form-group row">
                                                                        <label className="col-form-label col-lg-3 text-right">Reference Number</label>
                                                                        <div className="col-xl-6 col-lg-8">
                                                                            <input
                                                                                id="txtReferenceNumber"
                                                                                name="txtReferenceNumber"
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Reference Number"
                                                                                value={bookSheet.ReferenceNumber || ''}
                                                                                onChange={(e) => updateBookingDetails('ReferenceNumber', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                )}
                                                            </>
                                                        )}
                                                        {bookSheet.ID && bookSheet.PaymentMode === 13 && (
                                                            <>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Reference Number</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={bookSheet.ReferenceNumber || ''}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Payment Method</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <Select
                                                                            options={allSettlementList}
                                                                            value={allSettlementList.find(option => option.value === bookSheet.PaymentMethod) || null}
                                                                            isDisabled={true}
                                                                            placeholder="Select Payment Method"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        <table className="table table-bordered table-hover margin-b20">
                                                            <thead className="light-grey-background">
                                                                <tr>
                                                                    <th>Description</th>
                                                                    <th className="text-right">Amount (₹)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Green Fee</td>
                                                                    <td className="text-right">₹ {fees?.greenFee.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{fees.bucketBalls} Balls</td>
                                                                    <td className="text-right">₹ {fees?.bucketAmount.toFixed(2)}</td>
                                                                </tr>
                                                                {isClubSelected && (
                                                                    <tr>
                                                                        <td>Club</td>
                                                                        <td className='text-right'>₹ {fees?.club?.toFixed(2)}</td>
                                                                    </tr>
                                                                )}
                                                                {fees.discountAmount > 0 && (
                                                                    <tr>
                                                                        <td>Discount</td>
                                                                        <td className='text-right'>₹ {fees.discountAmount.toFixed(2)}</td>
                                                                    </tr>
                                                                )}
                                                                <tr>
                                                                    <td>SGST (9%)</td>
                                                                    <td className="text-right">₹ {fees?.sgst.toFixed(2)}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td>CGST (9%)</td>
                                                                    <td className="text-right">₹ {fees?.cgst.toFixed(2)}</td>
                                                                </tr>

                                                                <tr className="font-weight-bold">
                                                                    <td>Total</td>
                                                                    <td className="text-right">₹ {fees?.total.toFixed(2)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-12 text-right">
                                                        <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{bookSheet.ID ? 'Update Booking' : 'Save Booking' }</button>
                                                        {bookSheet &&
                                                            bookSheet.ID && <button id="btnCancel" type="button" className="btn btn-warning d-inline-block margin-l10" onClick={cancelBookingHandler}>Cancel Booking</button>
                                                        }
                                                        {bookSheet && bookSheet.ID && bookSheet.TrackingID && <button id="btnViewInvoice" type="button" className="btn btn-success d-inline-block margin-l10" onClick={() => window.open(`${apiUrl}/api/payment/invoice/${bookSheet.TrackingID}`, '_blank', 'noreferrer')}>View Invoice</button>}
                                                        <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MatBookingSheet;
